// src/contexts/ChatContext.js

import React, { createContext, useContext, useMemo, useCallback } from "react";
import { bootTawk, showTawkBubble, openTawkChat, hideTawk, identifyTawk } from "../utils/tawk";

const ChatContext = createContext(null);

export function ChatProvider({ children }) {
  // Low-level boot (script load)
  const bootChat = useCallback((opts) => bootTawk(opts), []);

  // Trial UX: bubble only
  const showBubble = useCallback(() => showTawkBubble(), []);

  // User intent: open chat window
  const openChat = useCallback(() => openTawkChat(), []);

  const hideChat = useCallback(() => hideTawk(), []);
  const identifyChat = useCallback((attrs) => identifyTawk(attrs), []);

  const value = useMemo(
    () => ({ bootChat, showBubble, openChat, hideChat, identifyChat }),
    [bootChat, showBubble, openChat, hideChat, identifyChat]
  );

  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
}

export function useChat() {
  const ctx = useContext(ChatContext);
  if (!ctx) throw new Error("useChat must be used within ChatProvider");
  return ctx;
}
